import { fileSize } from "lib/file";

export function FileSize({ size }: { size: number }) {
  return fileSize(size);
}
